import { ChevronDown, ChevronRightIcon } from 'lucide-react'
import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'
import { cn } from '../utils/cn'
import ColoredBar from './coloredBar'
import Container from './container'

export default function BannerProjects({
  backgroundImage,
  bgMobile,
  title,
  titleBold,
  iconSrc,
  iconAlt,
  iconText,
  iconTextBold,
  descriptionBold,
  description,
  footerText,
  brand,
}) {
  const { openModal } = useModal()
  return (
    <div className="relative">
      <div
        className={cn(
          `flex flex-col justify-end pb-10 space-y-10 w-full min-h-[calc(100vw+200px)] lg:min-h-auto lg:h-screen bg-[url('../assets/${bgMobile}')] lg:bg-[url(${backgroundImage})] bg-no-repeat bg-cover bg-center text-white`,
        )}
      >
        <Container className="flex flex-col lg:flex-row justify-between md:items-center lg:justify-evenly xl:justify-between h-fit z-10 md:m-auto lg:gap-10">
          <div className="space-y-5 text-left">
            <div className="text-[40px] md:text-6xl flex flex-col leading-[1.1] md:leading-[1]">
              {title && <span className="font-titillium-web-light">{title}</span>}
              {titleBold && <span className="font-titillium-web-bold">{titleBold}</span>}
            </div>

            <div className="items-center gap-2 hidden lg:flex">
              <img src={iconSrc} alt={iconAlt} />

                            <p className="text-xl">
                                <strong>{iconText}</strong>
                                {iconTextBold}
                            </p>
                        </div>
                    </div>
                    <div className="relative h-fit w-fit mt-4 md:mt-0">
                        <div className="bg-[#FFFFFF17] backdrop-blur-sm py-6 ps-6 md:ps-10 pe-6 rounded-[20px] text-white max-w-[473px] w-full font-titillium-web-regular text-sm text-center lg:text-left lg:text-lg">
                            <p>
                                {descriptionBold && (
                                    <>
                                        <span className="font-titillium-web-bold">
                                            {descriptionBold}
                                        </span>{" "}
                                        <br />{" "}
                                    </>
                                )}
                                {description}
                            </p>
                        </div>
                        <div className="absolute -top-3 left-[50%] -translate-x-[50%] lg:-translate-0 lg:top-0 lg:-left-5 lg:mt-5 size-6 lg:size-10 bg-white rounded-full text-black flex items-center justify-center">
                            <div className="hidden lg:flex">
                                <ChevronRightIcon />
                            </div>
                            <div className="flex items-center justify-center lg:hidden">
                                <ChevronDown className="size-4" />
                            </div>
                        </div>
                    </div>
                </Container>
                <Container className="font-inter-regular flex flex-col lg:flex-row items-center gap-6 justify-center relative z-20">
                    <div className="lg:hidden flex items-center justify-center gap-2">
                        <img
                            className="block h-7 object-fill"
                            src={
                                brand === "nex2ai"
                                    ? "../assets/icone-projectiva-nex2ai.png"
                                    : brand === "omnicore"
                                    ? "../assets/icone-projectiva-omnicore.png"
                                    : "../assets/icone-projectiva-behub.png"
                            }
                            alt="Logo"
                        />

                        <p className="block text-sm font-inter-light">
                            {brand === "nex2ai" ? (
                                <>
                                    <strong className="font-inter-bold">
                                        nex
                                    </strong>
                                    2ai
                                </>
                            ) : brand === "omnicore" ? (
                                <>
                                    <strong className="font-inter-bold">
                                        omni
                                    </strong>
                                    core
                                </>
                            ) : (
                                <>
                                    <strong className="font-inter-bold">
                                        be.
                                    </strong>
                                    hub
                                </>
                            )}
                        </p>
                    </div>
                    <p className="block tracking-[2px] text-center text-xs lg:text-base lg:text-left">
                        {footerText}
                    </p>
                    <button
                        onClick={() => openModal(<FormularioRD />)}
                        className={cn(
                            "cursor-pointer text-xs text-white font-medium py-3 px-10 lg:py-1 lg:px-8 rounded-[5px] lg:text-lg shadow-md inline-block hover:scale-105 transition-all duration-300 tracking-wider",
                            brand === "behub" &&
                                "bg-gradient-to-r from-[#4B3BDB] to-[#A002CB]",
                            brand === "omnicore" &&
                                "bg-gradient-to-r from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]",
                            brand === "nex2ai" &&
                                "bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#910CCE]"
                        )}
                    >
                        Quero me conectar
                    </button>
                </Container>
            </div>
            <img
                src="../assets/black-shadow.png"
                alt=""
                className="block absolute bottom-0 w-full left-0 h-[60vh] z-0"
            />
            <ColoredBar
                hoveredBrand={brand}
                brands={[{ id: brand }]}
                className="relative"
            />
        </div>
    );
}
